import { reactive, computed } from 'vue'

const DEFAULT_THEME = 'light' // default per product decision: light first

const state = reactive({
  theme: localStorage.getItem('todo_theme') || DEFAULT_THEME,
})

/** Apply theme to <html data-theme>. Call on app boot and on every change. */
export function applyTheme() {
  document.documentElement.setAttribute('data-theme', state.theme)
}

function setTheme(theme) {
  state.theme = theme
  localStorage.setItem('todo_theme', theme)
  applyTheme()
}

export function useTheme() {
  return {
    theme:       computed(() => state.theme),
    isDark:      computed(() => state.theme === 'dark'),
    setTheme,
    toggleTheme: () => setTheme(state.theme === 'dark' ? 'light' : 'dark'),
    applyTheme,
  }
}
